export default __webpack_public_path__ + "static/media/playbackPause.c8606a44.svg";